import { Component, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { HeaderButtonManager } from './header-button-manager';

@Component({
  imports: [MatButton, MatIcon],
  selector: 'header-button',
  styleUrl: './header-button.component.scss',
  templateUrl: './header-button.component.html',
})
export class HeaderButtonComponent {
  public manager = input.required<HeaderButtonManager>();
}
